import React from 'react';

const stats = [
   { value: '10+', label: 'Years' },
   { value: '100+', label: 'Apps Built' },
   { value: 'Global', label: 'Remote' },
];

const BioSection = () => {
   return (
      <div className="glass-card p-5 sm:p-6 animate-fadeUp">
         <div className="section-eyebrow">About me</div>
         <h2 className="mt-3 font-display text-xl sm:text-2xl font-bold tracking-tight">
            Hi, I&apos;m <span className="text-shimmer">Tanbir Hossen Sarkar.</span>
         </h2>
         <p className="mt-3 text-[13.5px] leading-relaxed text-zinc-600 dark:text-zinc-400">
            Back in{' '}
            <span className="font-semibold text-zinc-900 dark:text-zinc-100">2013</span>,
           My journey started with building websites, just curiosity and a browser. From there,
           one thing led to another. Web turned into apps, apps turned into mobile, and mobile
           grew into a deep interest in how apps can be{' '}
            <span className="font-semibold text-zinc-900 dark:text-zinc-100">built to last and stay secure</span>.
            Over the years I&apos;ve worked across many areas of tech, picked up new skills along the way,
            and built 100+ Android applications. Today I run{' '}
            <span className="font-semibold text-zinc-900 dark:text-zinc-100">FixBuild Core X</span>,
            where that same curiosity drives everything.
         </p>

         <div className="mt-5 grid grid-cols-3 gap-2 sm:gap-3">
            {stats.map((s) => (
               <div key={s.label} className="stat-block">
                  <span className="font-display text-lg sm:text-xl font-bold text-zinc-900 dark:text-white">
                     {s.value}
                  </span>
                  <span className="mt-0.5 text-[10px] sm:text-[11px] font-medium uppercase tracking-wider text-zinc-500 dark:text-zinc-400">
                     {s.label}
                  </span>
               </div>
            ))}
         </div>
      </div>
   );
};

export default BioSection;
